import * as React from "react";
const SvgMitteilungen = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Mitteilungen">
    <path
      fill="currentColor"
      d="M216.13 169.77c-3.84-1.62-23.02-13.29-23.51-83.96-.15-22.53-28.01-34.6-46.89-40.2-3.66-5.96-10.22-9.95-17.73-9.95s-14.07 3.99-17.73 9.95c-18.89 5.6-46.74 17.67-46.89 40.2-.48 70.67-19.67 82.34-23.51 83.96-5.09 2.15-8.38 7.14-8.38 12.71v17.06c0 6.23 5.05 11.27 11.27 11.27h170.48c6.23 0 11.27-5.05 11.27-11.27v-17.06c0-5.57-3.29-10.56-8.38-12.71m-6.62 26.04H46.49v-12.58c12.06-5.58 31.4-25.71 31.89-97.33.1-15.11 32.64-25.99 49.63-29.24 16.99 3.23 49.52 14.09 49.62 29.24.49 71.62 19.83 91.75 31.89 97.33v12.58ZM128 243.36c-15.09 0-27.37-12.28-27.37-27.37h15c0 6.82 5.55 12.37 12.37 12.37s12.37-5.55 12.37-12.37h15c0 15.09-12.28 27.37-27.37 27.37"
    />
  </svg>
);
export default SvgMitteilungen;
